export default __webpack_public_path__ + "static/media/ic_sierra_leone.4adaddef.svg";